
import React, { useState, useEffect, useCallback } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent, useMediaQuery } from '@mui/material'
// import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'

import '../contactos/modalContacts.css'

import { Tasks } from '../../models/tasks'
// import { SeccionGeneral } from './SeccionGeneral'
import { Model } from '../../models/model'
import { SeccionGeneralMovil } from './SeccionGeneralMovil';
import { useSelector } from 'react-redux';

export const DialogFormMovil = ({ open, setOpen, taskId = null, refreshObj = null }) => {
    // console.log({ refreshObj })

    const isMobile = useMediaQuery('(max-width:768px)')
    // const theme = useTheme();
    //const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const { uid } = useSelector(state => state.auth)
    const [previuosInfo, setPreviuosInfo] = useState({})
    const [labelsList, setLabelsList] = useState([])

    const [form, setForm] = useState({
        id: taskId || 0,
        tipo: 'task',
        type: 'task',
        origen: null,
        id_origen: null,
        nombre: '',
        created: false,
        fecha_inicio: '',
        fecha_fin: new Date(),
        date_change_option: 'esta_tarea',
        id_responsable: uid,
        estado: 'por hacer',
        labels: []
    })

    const handleGetTask = useCallback(async () => {
        const resultTask = await Model.getOne({ url: `tasks/${taskId}` })

        setForm(prev => ({
            ...prev,
            ...resultTask,
            date_change_option: 'esta_tarea'
        }))

        // setForm({
        //     ...resultTask,
        //     date_change_option: 'esta_tarea'
        // })

        setPreviuosInfo(resultTask)

    }, [taskId])

    const handleGetLabels = async () => {
        const resultslabels = await Model.getAll({ url: 'labels' })
        setLabelsList(resultslabels || [])
    }

    const handleChange = async ({ target }) => {
        const { name, value, type, checked } = target
        const newValue = (type === 'checkbox' ? checked : value)

        setForm({
            ...form,
            [name]: newValue
        })

    }

    const handleChangeDate = (newDates) => {
        setForm({
            ...form,
            fecha_inicio: newDates.fecha_inicio,
            fecha_fin: newDates.fecha_fin,
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (form.nombre === '') {
            toast.warn("Ingrese nombre tarea")
            return false
        }

        if (form.id > 0) {
            await Tasks.update(form)

        } else {

            await Tasks.save(form)
            setForm({
                ...form,
                nombre: '',
            })
        }

        if (refreshObj) {
            await refreshObj.fn_(refreshObj.filters_)
        }

        setOpen(false)

    }

    useEffect(() => {
        if (parseInt(taskId) > 0) {
            handleGetTask()
        }
    }, [handleGetTask, taskId])

    useEffect(() => {
        if (parseInt(taskId) > 0) {
            handleGetLabels()
        }
    }, [taskId])

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={isMobile}
            PaperProps={{
                className: isMobile ? '' : 'min-w-fit'
            }}
        >
            <div className={!isMobile ? `ContainerDialogs` : ''} style={{ width: !isMobile ? '700px' : '' }}>
                <DialogTitle id="scroll-dialog-title" style={{ position: 'absolute', right: '0px', top: '0px' }}>
                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <SeccionGeneralMovil
                        form={form}
                        setForm={setForm}
                        handleChange={handleChange}
                        handleChangeDate={handleChangeDate}
                        handleSubmit={handleSubmit}
                        handleInitGetTasks={() => false}
                        refreshObj={refreshObj ? refreshObj : () => false}
                        previuosInfo={previuosInfo}
                        labelsList={labelsList}
                    />
                </DialogContent>
            </div>
        </Dialog>
    )
}